<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [],
        orderStateOptions: [],
        form: [
          { // 订单号码
            label: '订单号码',
            value: 'orderNo',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 发车时间
            label: '发车时间',
            value: 'dependTime',
            type: 'date',
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 录入时间
            label: '录入时间',
            value: 'createDate',
            type: 'date',
            placeholder: '请选择录入时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 主驾姓名
            label: '主驾姓名',
            value: 'carDriverMan',
            type: 'input',
            placeholder: '请输入主驾姓名',
          },
          { // 客户名称
            label: '客户名称',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 客户单号
            label: '客户单号',
            value: 'customNumber',
            type: 'input',
            placeholder: '请输入客户单号',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'input',
            placeholder: '请选择归属部门',
          },
          { // 跟单人员
            label: '跟单人员',
            value: 'localUserName',
            type: 'input',
            placeholder: '请输入跟单人员',
          },
          { // 录入人员
            label: '录入人员',
            value: 'operateName',
            type: 'input',
            placeholder: '请输入录入人员',
          },
          { // 副驾姓名
            label: '副驾姓名',
            value: 'copilotMan',
            type: 'input',
            placeholder: '请输入副驾姓名',
          },
          { // 线路
            label: '线路',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路',
          },
          { // 挂车车牌
            label: '挂车车牌',
            value: 'trailerPlate',
            type: 'input',
            placeholder: '请输入挂车车牌',
          },
          { // 订单状态
            label: '订单状态',
            value: 'orderState',
            type: 'select',
            placeholder: '请选择订单状态',
            options: [],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.dependTime && searchBoxData.dependTime.length) {
        searchBoxData.carDependDate = this.formatDate(searchBoxData.dependTime[0]);
        searchBoxData.carDependDateEnd = this.formatDate(searchBoxData.dependTime[1]);
        delete searchBoxData.dependTime;
      }
      if (searchBoxData.createDate && searchBoxData.createDate.length) {
        searchBoxData.orderCreateDate = this.formatDate(searchBoxData.createDate[0]);
        searchBoxData.orderCreateDateEnd = this.formatDate(searchBoxData.createDate[1]);
        delete searchBoxData.createDate;
      }
      searchBoxData.orderType = 2;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ORDER_STATE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.orgIdOptions = [
      { label: '全部', value: -1 },
      ...((await getDepartmentAllList()) || []),
    ];
    this.searchBoxData.orderStateOptions = [
      { label: '全部', value: -1 },
      ...safeEnum(0),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
